(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["produkt-tabs"] && !Shopify.designMode) return;
  try {
    
  function ptInit(root) {
    if (!root || root.dataset.ptInit) return;
    root.dataset.ptInit = '1';

    var labelMore = root.getAttribute('data-label-more') || 'Mehr erfahren';
    var labelLess = root.getAttribute('data-label-less') || 'Weniger anzeigen';
    var scrollOffset = parseInt(root.getAttribute('data-scroll-offset'), 10) || 0;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pt__tab'));
    var panels = root.querySelectorAll('.pt__panel');

    function activate(target) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-target') === target;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-panel') === target;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-target'));
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
        tabs[next].focus();
        activate(tabs[next].getAttribute('data-target'));
      });
    });

    var wrapper = root.querySelector('.pt-crm-wrapper');
    if (wrapper) {
      var animator = wrapper.querySelector('.pt-crm-animator');
      var content = wrapper.querySelector('.pt-crm-content');
      var btn = wrapper.querySelector('.pt-crm-btn');
      var label = wrapper.querySelector('.pt-crm-label');

      requestAnimationFrame(function () {
        if (content.scrollHeight <= content.clientHeight + 5) {
          btn.style.display = 'none';
          content.style.maskImage = 'none';
          content.style.webkitMaskImage = 'none';
        }
      });

      btn.addEventListener('click', function () {
        var willExpand = !animator.classList.contains('expanded');
        animator.classList.toggle('expanded', willExpand);
        btn.classList.toggle('expanded', willExpand);
        btn.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
        label.textContent = willExpand ? labelLess : labelMore;
        btn.setAttribute('aria-label', willExpand ? labelLess : labelMore);

        // Beim Zuklappen NUR nach oben andocken – nie nach unten.
        if (!willExpand) {
          var target = window.pageYOffset + root.getBoundingClientRect().top - scrollOffset;
          if (target < window.pageYOffset) {
            window.scrollTo({ top: target, behavior: 'smooth' });
          }
        }
      });
    }
  }

  function ptInitAll(scope) {
    (scope || document).querySelectorAll('.pt').forEach(ptInit);
  }

  ptInitAll();
  document.addEventListener('shopify:section:load', function (e) { ptInitAll(e.target); });

  } catch(e) { console.error(e); }
})();
})();
